import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { OrderSideEnum } from '@modules/orders-module/enums/order-side.enum'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'
import { HighlightDirective } from '@shared/directives/higlight.directive'
import { TitleOrderTypePipe } from '@modules/orders-module/pipes/title-order-type.pipe'
import { TitleOrderTermPipe } from '@modules/orders-module/pipes/title-order-term.pipe'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { PricePipe } from '@shared/pipes/price.pipe'
import { QuantityPipe } from '@shared/pipes/quantity.pipe'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-info-body-preview',
	templateUrl: './order-info-body-preview.component.html',
	styleUrl: './order-info-body-preview.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, HighlightDirective, TitleOrderTypePipe, TitleOrderTermPipe, PricePipe, QuantityPipe],
})
export class OrderInfoBodyPreviewComponent {
	protected readonly orderSideEnum: typeof OrderSideEnum = OrderSideEnum
	protected readonly orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum

	@Input() order: OrderInterface | null = null
}
